/**
 * ajax请求配置
 */
import axios from 'axios'
import NProgress from 'nprogress'
import {serverUrl, url} from "./globalVar"
//import Qs from 'qs'

// import cookie from '../../static/js/cookie.js'

// axios默认配置
// axios.defaults.timeout = 60000;   // 超时时间
axios.defaults.baseURL = serverUrl;  // 默认地址

//整理数据
axios.defaults.transformRequest = function (data) {
//data = Qs.stringify(data);
    data = JSON.stringify(data);
    return data;
};

axios.interceptors.request.use(
    config => {
        // //config.data = JSON.stringify(config.data);
        let token = sessionStorage.getItem("authorization");
        if (token) {
            config.headers['Authorization'] = token;
        }
        if(!config.headers['Content-Type']){
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
        }

        // //判断是否存在ticket，如果存在的话，则每个http header都加上ticket
        // if (cookie.get("token")) {
        //     //用户每次操作，都将cookie设置成2小时
        //     config.headers.token = cookie.get("token");
        //     config.headers.name= cookie.get("name");
        // }
        NProgress.start();
        return config;
    },
    error => {
        NProgress.done();
        return Promise.reject(error.response);
    });

// 路由响应拦截
// http response 拦截器
axios.interceptors.response.use(
    response => {
        NProgress.done();
        if (response.data.status === 401) {
            window.location.href = url + "/";
        } else {
            return response;
        }
    },
    error => {
        NProgress.done();
        return Promise.reject(error)   // 返回接口返回的错误信息
    });
export default axios;


// WEBPACK FOOTER //
// ./src/axios-init.js